import { ScriptMap } from "./tools";

/**
 * Defines the interface that exposes all exported scripts in this project.
 */
export interface ISceneScriptMap {
	"src/scenes/GameCore.ts": ScriptMap;
	"src/scenes/Player.ts": ScriptMap;
	"src/scenes/PosterBoard.ts": ScriptMap;
	"src/scenes/WVCamera.ts": ScriptMap;
	"src/scenes/WVTarget.ts": ScriptMap;
}

/**
 * Defines the map of all available scripts in the project.
 */
export const scriptsMap: ISceneScriptMap = {
	"src/scenes/GameCore.ts": require("./GameCore"),
	"src/scenes/Player.ts": require("./Player"),
	"src/scenes/PosterBoard.ts": require("./PosterBoard"),
	"src/scenes/WVCamera.ts": require("./WVCamera"),
	"src/scenes/WVTarget.ts": require("./WVTarget"),
}
